import React, { Component } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { imgStoragePath } from '../../../../constants'
import InfoIcon from '../../../../shared/assets/img/light_info_icon.svg';
class FeedbackStatusDetails extends Component{
  constructor(props){
    super(props)
    this.state = {
      popoverOpen: false
    }
  }

  togglePopover = () =>{
    this.setState({
      popoverOpen: !this.state.popoverOpen
    })
  }

  render(){
    return(
      <div className="status-details" style={{ display : 'inline' }}>
        <img style={{ position: 'relative', marginLeft : '5px' }} width="18" src={InfoIcon} id="status_detail" onClick={() => this.togglePopover()}/>
        <Popover className="status-details-popover" placement="bottom" isOpen={this.state.popoverOpen} target="status_detail" toggle={() => this.togglePopover()}>
            <PopoverHeader>Rating</PopoverHeader>
            <PopoverBody>
              <ul>
                <li>1 - Highly Unsatisfied</li>
                <li>2 - Unsatisfied</li>
                <li>3 - Ok</li>
                <li>4 - Satisfied</li>
                <li>5 - Very Satisfied</li>
              </ul>
            </PopoverBody>
        </Popover>
      </div>
    )
  }
}

export default FeedbackStatusDetails
